/* eslint-disable @typescript-eslint/no-explicit-any */
import { MoreOutlined } from '@ant-design/icons'
import { StatusMemberRegisterWaiting } from 'app/api/event/model'
import { ITradeUnionMember } from 'app/api/tradeUnionMembers/model'
import { BaseButton } from 'app/components/common/BaseButton'
import { BasePopover } from 'app/components/common/BasePopover'
import { BaseRow } from 'app/components/common/BaseRow'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { convertColumnTable } from 'app/components/tables/BaseTableReport/hook'
import {
  ILocation
} from 'app/containers/EventManagement/layouts/CreateEvent/type'
import { isEqual } from 'lodash'
import { ModalApproveManyMember } from '../ModalApproveManyMember'
import { ModalApproveMember } from '../ModalApproveMember'
import { ModalRejectMember } from '../ModalRejectMember'

interface IData {
  key?: number
  id?: number
  tum?: ITradeUnionMember
  reason?: string
}

export const ActionRegisteredByStatusLayout = ({
  status,
  locations,
  data,
  isLoading,
}: {
  status: StatusMemberRegisterWaiting
  locations?: ILocation[]
  data: any[]
  isLoading?: boolean
}) => {
  return (
    <BaseSpace>
      {isEqual(status, StatusMemberRegisterWaiting.WAITING) ? (
        <BaseRow justify={'end'} gutter={16}>
          <ModalApproveManyMember listMember={data} locations={locations} />
        </BaseRow>
      ) : null}

      <BaseTableManagement
        dataSource={data}
        columns={[
          convertColumnTable<IData>({
            title: 'STT',
            key: 'key',
            classNameWidthColumnOverwrite: 'number-column',
            render: value => {
              return (
                <BaseText children={value} fontWeight="medium" opacity="0.7" />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Tên đoàn viên',
            key: 'tum',
            classNameWidthColumnOverwrite: 'big-column',
            render: (_, record) => {
              return (
                <BaseText
                  children={record?.tum?.fullName}
                  fontWeight="semibold"
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Email',
            key: 'tum',
            render: (_, record) => {
              return (
                <BaseText
                  children={record?.tum?.email}
                  fontWeight="medium"
                  opacity="0.7"
                />
              )
            },
          }),
          convertColumnTable<IData>({
            title: 'Đơn vị',
            key: 'tum',
            render: (_, record) => {
              return (
                <BaseText
                  children={record?.tum?.tenDonVi}
                  fontWeight="medium"
                  opacity="0.7"
                />
              )
            },
          }),

          ...(isEqual(status, StatusMemberRegisterWaiting.WAITING)
            ? [
                convertColumnTable<IData>({
                  title: '',
                  key: 'key',
                  width: '10%',
                  classNameWidthColumnOverwrite: 'number-column',
                  render: (_, record) => {
                    return (
                      <BasePopover
                        content={
                          <BaseSpace>
                            <ModalApproveMember
                              id={record?.id}
                              locations={locations}
                            />
                            <ModalRejectMember id={record?.id} />
                          </BaseSpace>
                        }
                        trigger={'click'}
                      >
                        <BaseButton
                          type="text"
                          icon={<MoreOutlined rev={undefined} />}
                        />
                      </BasePopover>
                    )
                  },
                }),
              ]
            : []),

          ...(isEqual(status, StatusMemberRegisterWaiting.REJECTED)
            ? [
                convertColumnTable<IData>({
                  key: 'key',
                  title: 'Lý do từ chối',
                  render: (_, record) => {
                    return (
                      <BaseText
                        children={record?.reason ?? ''}
                        colorText="statesRedColor"
                        fontWeight="medium"
                      />
                    )
                  },
                }),
              ]
            : []),
        ]}
        loading={isLoading}
        scroll={{ x: true }}
      />
    </BaseSpace>
  )
}
